const Divider = {
  isComponent: el => el.tagName === 'HR',
  model: {
    defaults: Object.assign({}, {
      tagName: 'hr',
      draggable: true,
      droppable: false,
      copyable: true,
      attributes: {
        id: 'divider'
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        },
        {
          name: 'attr-vertical',
          label: 'Vertical',
          type: 'checkbox'
        }
      ]
    }),
    init() {
      const attributes = this.getAttributes()
      if (this.getClasses().includes('divider--vertical')) {
        attributes['attr-vertical'] = true
      } else {
        attributes['attr-vertical'] = false
      }
      this.setAttributes(attributes)
      this.on('change:attributes:attr-vertical', this.handleVerticalChange)
    },
    handleVerticalChange() {
      const targetAttr = this.getAttributes()['attr-vertical']
      if (targetAttr) {
        this.addClass('divider--vertical')
      } else {
        this.removeClass('divider--vertical')
      }
    }
  }
}

export default Divider
